import React, { useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import { validateTextOnlyAlphanumeric, validatorField } from "../../Utils/validators";
import ErrorCustom from "../../Components/errorCustom";
import { useFormContext } from "react-hook-form";

interface Props {
  disableRemove: boolean;
  parentsData: Array<any>;
  parent: Object;
  index: number;
  removeParent: Function;
  count: number;
}

export const ParentForm = ({
  disableRemove,
  parentsData,
  parent,
  index,
  removeParent,
  count,
}: Props) => {
  const methods = useFormContext();
  const { register, errors, watch, setValue } = methods;

  const nameControl = parentsData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Nombres");

  const lastNameControl = parentsData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Apellidos");

  const typeAccountControl = parentsData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Tipo de documento");
  
  const nroDocumentControl = parentsData
    .flatMap((item) => item.childControls)
    .find((child) => child.metadata.placeholder === "Nro. documento");
   
    const relationshipControl = parentsData
    .flatMap((item) => item.childControls ? item.childControls : [item])
    .find((child) => child.metadata.placeholder === "Parentesco");


  const nameSk = Object.keys(parent)[0];
  const lastNameSk = Object.keys(parent)[1];
  const typeAccountSk = Object.keys(parent)[2];
  const nroDocumentoSk = Object.keys(parent)[3];
  const relationshipSk = Object.keys(parent)[4];

  const remove = (e: any) => {
    e.preventDefault();
    if(disableRemove) return;
    removeParent(index);
  };

  return (
    <>
      <div
        className={`beneficiaryForm${index === 0 ? " first" : ""}`}
        style={{ position: "relative" }}
      >
        <div className="clientForm__beneficiary-box">
          <div className="clientForm__beneficiary-box-icon">
            <IconBeneficiario />
            <div className="clientForm__beneficiary">
              Pariente {(index+1) + 1}
            </div>
          </div>
          {count > 0 && (
            <p
              className={`clientForm__eliminar ${disableRemove ? "disabled-action" : ""}`}
              onClick={(e) => {
                remove(e);
              }}
            >
              Eliminar
            </p>
          )}
        </div>
      </div>

      {parentsData[0] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="clientForm__control input-field">
              <input
                id={nameSk}
                name={nameSk}
                type="text"
                autoComplete="off"
                maxLength={nameControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={nameSk}
              >
                {nameControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={nameSk} />
            </div>

            <div className="clientForm__control input-field">
              <input
                id={lastNameSk}
                name={lastNameSk}
                type="text"
                autoComplete="off"
                maxLength={lastNameControl.metadata.maxLength}
                ref={register({
                  validate: {
                    validatorField,
                  },
                })}
              />
              <label
                htmlFor={lastNameSk}
              >
                {lastNameControl.metadata.placeholder}
              </label>
              <ErrorCustom errors={errors} name={lastNameSk} />
            </div>
          </div>
        </div>
      )}

      {parentsData[1] && (
        <div className="question__control input-field">
          <div className="group-form">
            <div className="question__control input-field">
              <select 
                name={typeAccountSk} 
                id={typeAccountSk}
                ref={register({ validate: validatorField })}
              >
                <option value={""} disabled selected>
                  {typeAccountControl.metadata.placeholder}
                </option>
                {typeAccountControl.metadata.options.map((option: any, idx: number) => (
                  <option value={option} key={idx}>
                    {option}
                  </option>
                ))}
              </select>
              <ErrorCustom errors={errors} name={typeAccountSk} />
            </div>
            
            <div className="clientForm__control input-field">
              <input 
                id={nroDocumentoSk} 
                name={nroDocumentoSk} 
                type="text" 
                autoComplete="off"
                maxLength={nroDocumentControl.metadata.maxLength}
                ref={register({ validate: validatorField })}
              />
              <label htmlFor={nroDocumentoSk}>{nroDocumentControl.metadata.placeholder}</label>
              <ErrorCustom errors={errors} name={nroDocumentoSk} />
            </div>
          </div>
        </div>
      )}

      {parentsData[2] && (
        <div className="question__control input-field">
           <select 
              name={relationshipSk} 
              id={relationshipSk}
              ref={register({ validate: validatorField })}
            >
              <option value={""} disabled selected>
                {relationshipControl.metadata.placeholder}
              </option>
              {relationshipControl.metadata.options.map((option: any, idx: number) => (
                <option value={option} key={idx}>
                  {option}
                </option>
              ))}
            </select>
            <ErrorCustom errors={errors} name={relationshipSk} />
        </div>
      )}
    </>
  );
};
